const UNLOCKED = 'Разблокирован'

const ADMIN_LOCKED = 'Заблокирована админ панель'

const LOCKED = 'Заблокирован сайт'

const POSTPONEMENT = 'Отсрочка'

export default {
    data() {
        return {
            statuses: {
                UNLOCKED,
                ADMIN_LOCKED,
                LOCKED,
                POSTPONEMENT,
            },

            lockStatuses: {
                ADMIN_LOCKED,
                LOCKED,
                POSTPONEMENT,
            }
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/projectLockStatuses.js